// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5609229f","453":"30900952","455":"c8fae1fc","644":"a75032df","970":"ce9e018c"}[chunkId] + ".chunk.js";
};